<div *ngIf="assetName && audioFile" class="viewer-audio">
  <!-- Audio tile -->
  <zbp-audio-player
    playerTitle="Audio"
    [assetName]="assetName"
    [audioFile]="audioFile"
  />

  <!-- Separate transcript tile (always shown if transcript exists; expands in place when clicked) -->
  @if(transcript) {
    <div
      id="transcript-tile"
      class="transcript-tile"
      role="region"
      [attr.aria-expanded]="showTranscript"
      [attr.aria-label]="'Audio transcript ' + (showTranscript ? '(expanded)' : '(collapsed)')">
      <button
        id="transcript-trigger"
        class="transcript-trigger"
        (click)="toggleTranscript()"
        type="button"
        [attr.aria-expanded]="showTranscript"
        aria-label="transcript"
        aria-controls="transcript-content">
        <img id="transcript-icon" alt="Transcript Icon" src="../../../assets/img/transcriptIcon.svg" />
        <span class="transcript-trigger-text">Transcript</span>
      </button>

      <!-- Expanded content (inside the same tile, shown below button when expanded) -->
      @if(showTranscript) {
        <div
          id="transcript-content"
          class="transcript-content-area">
          <section class="transcript-section">
            <div class="transcript-text" [innerHTML]="transcript"></div>
          </section>
        </div>
      }
    </div>
  }
</div>
